import { Fragment } from "react/jsx-runtime";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { KnowledgebaseTitle } from "../../../Constants/Constants";
import { LatestArticlesVideosknowledge } from "../../../Data/Miscellaneous/FAQ";
import FaqWidgets from "../FAQ/FaqWidgets";
import FeaturedTutorials from "../FAQ/FeaturedTutorials";
import LatestArticlesVideos from "../FAQ/LatestArticlesVideos";
import BrowseArticles from "./BrowseArticles";
import KnowledgeSearch from "./KnowledgeSearch";

const KnowledgebaseContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={KnowledgebaseTitle} parent={KnowledgebaseTitle} />
      <Container fluid>
        <Row>
          <KnowledgeSearch />
          <FaqWidgets />
          <BrowseArticles />
          <FeaturedTutorials />
          <LatestArticlesVideos titleClass="f-w-600" rowClass="latest-articles" divClass="articles-icons" data={LatestArticlesVideosknowledge} />
        </Row>
      </Container>
    </Fragment>
  );
};
export default KnowledgebaseContainer;
